import createDataContext from 'context/createDataContext';
import reducer, { initialState } from 'context/language/reducer';
import * as actions from 'context/language/actions';

export const { Context: LanguageContext, Provider: LanguageProvider } = createDataContext(
  reducer,
  { ...actions },
  initialState
);
